import { ROLE_LABEL_BY_ROLE } from './userConstants';
import { roleLabelForRole } from './userHelpers';

/**
 * Build add/edit API body. Name and email are never sent.
 * Always sends locked role + role_label pairs and status.
 */
export function buildUserPayload(form = {}) {
  const role = form.role;
  const role_label = roleLabelForRole(role) || ROLE_LABEL_BY_ROLE[role] || '';
  return {
    ...(form.user_id ? { user_id: form.user_id } : {}),
    role,
    role_label,
    location_ids: Array.isArray(form.location_ids) ? form.location_ids.slice() : [],
    status: form.status !== false,
  };
}

